const ID = {
  NFMFASESSION_ACCOUNTOPTIONS_LOGIN_BUTTON_ID:'nf-mfasession-account-options-login-button-id',
  NFMFASESSION_NFCREATENCIDACCOUNT_CONTINUE_NCID_BUTTON_ID:'nf-mfasession-nf-create-ncid-account--continue-button-id',
  NFMFASESSION_NFCREATENCIDACCOUNT_LOGIN_BUTTON_ID:'nf-mfasession-nf-create-ncid-account-login-button-id',
  NFMFASESSION_NFACCOUNTLOCK_OK_BUTTON_ID:'nf-mfasession-nf-account-lock-ok-button-id',
  NFMFASESSION_NFLEARNMORE_CLOSE_BUTTON_ID: 'nf-mfasession-nf-learn-close-button-id',
  NFMFASESSION_NFCONFIRMCODE_CONFIRM_BUTTON_ID:'nf-mfasession-nf-confirm-code-confirm-button-id',
  NFMFASESSION_ERROR_OK_BUTTON_ID:'nf-mfasession-error-ok-button-id',
  NFMFASESSION_INCORRECTLOGIN_RETRY_BUTTON_ID:'nf-mfasession-incorrect-login-retry-button-id',
  NFMFASESSION_QUESTIONS_NEXT_BUTTON_ID:'nf-mfasession-question-next-button-id',
  NFMFASESSION_REMEMBER_DEVICE_CONFIRM_BUTTON_ID:'nf-mfasession-remember-device-confirm-button-id',
  NFMFASESSION_TEMPORARILY_LOCKED_OK_BUTTON_ID:'nf-mfasession-temporarily-locked-ok-button-id',
  NFMFASESSION_AUTO_NEWBORN_LOCKED_CLOSE_BUTTON_ID:'nf-mfasession-auto-newborn-close-button-id',  
};

/* eslint-disable import/prefer-default-export */
export { ID };
